/**
 * Password-reset feature strings.
 *
 * Namespace: resetPassword
 */
export const resetPassword = {
  // Page
  page: {
    title: "Új jelszó megadása",
    subtitle: "Adja meg az új jelszavát",
  },

  // Form fields
  form: {
    passwordLabel: "Új jelszó",
    passwordPlaceholder: "••••••••",
    passwordHelperText: "Legalább 8 karakter",
    confirmPasswordLabel: "Jelszó megerősítése",
    confirmPasswordPlaceholder: "••••••••",
    submitButton: "Megerősítés",
  },

  // Success
  success: {
    title: "Jelszó megváltoztatva!",
    message: "A jelszava sikeresen megváltozott. Most már bejelentkezhet az új jelszavával.",
    goToLogin: "Tovább a bejelentkezéshez",
  },

  // Errors
  errors: {
    invalidToken: "A jelszó-visszaállító link érvénytelen vagy lejárt.",
    expiredToken: "A jelszó-visszaállító link lejárt. Kérjen egy új linket.",
    // A110 S4: the card's own subtitle for the invalid-link state. The page subtitle asks for a new
    // password, which this link no longer allows.
    subtitle: "Az új jelszó megadása nem sikerült.",
  },
} as const;
